<template>
	<div style="padding:3%">
		<div class="title" style="text-align:center;">互联网诊疗风险告知及知情同意书</div>
		<p>“在线常见病、慢性病复诊”是一项在线诊疗服务（以下简称“本服务”）。本服务由入驻平台的互联网医院及其医务人员向您提供。作为平台方，我们将对平台内的互联网医院及医务人员采取必要的平台管理措施，督促其严格按照医疗卫生法律法规和诊疗规范及互联网在线诊疗规范。 您在使用本服务之前，请务必仔细阅读下列文本。在此郑重提示：一旦您使用了本服务，即表示您已经完整、准确的了解了本声明所提示的所有内容，并同意接受本声明全部条款的约束。</p>
		
		<p>根据《互联网诊疗管理办法（试行）》、《互联网医院管理办法（试行）》、《远程医疗服务管理办法（试行）》等法规的要求，您应知晓互联网诊疗相关的执业规则并接受风险告知并签署知情同意书。</p>
		
		<p>1.互联网诊疗相关执业规则</p>
		
		<p>互联网医院开展部分常见病、慢性病复诊时，医师应当掌握您病历资料，确定已有明确诊断后，针对相同诊断进行复诊并开具处方。</p>
		
		<p>互联网医院不能开具麻醉药品、精神类药品处方，以及其他用药风险较高，有其他特殊管理规定的药品处方。为6岁以下的儿童开具用药处方时，应当有监护人和相关专业医师陪伴。</p>
		
		<p>互联网医院不能直接进行体格检查和实施检查、检验等诊查手段，一旦医生认为您出现病情变化且需要医务人员亲自诊查时，或复诊疾病属于疑难杂症、出现危急重症等情形时，医生在在线诊疗过程中能够采取的有效措施较为有限。前述情形下医生有权终止本次诊疗活动，您应积极配合到实体医疗机构就诊。</p>
		
		<p>互联网医院可以提供药品配送相关的服务，但实际服务提供方为合作第三方。相关的服务质量和售后保障由第三方负责。当发生不良事件时，您应积极、主动上报。</p>
		
		<p>2.互联网诊疗潜在风险告知及对策</p>
		
		<p>接受互联网诊疗可能出现如下潜在风险，有些不常见的风险未能一一列出，如果您有疑问应与医生讨论。</p>
		
		<p>2.1 受限于互联网诊疗本身的局限性（如医生不能面诊、触诊等，无法通过相关的诊查手段及检查、检验结果准确判断病情的进展），医生给出的本次诊疗方案依赖于您所上传的资料和描述的症状，以及既往的病历资料、临床诊断。如前述信息不准确或不全面，将对本次诊疗方案的合理制定产生一定的影响，如因此导致误诊误治的不利后果，患者需对此承担相应责任。</p>
		
		<p>2.2 由于疾病本身的特殊性和复杂性，您本身的体质状况，及现有医疗水平条件的限制等，都存在可能发生各种并发症和危害自身生命健康的意外风险。</p>
		
		<p>由于疾病本身的复杂性，以及诊疗措施疗效出现的延后性，诊疗方案、健康管理方案可能不会达到您期许的效果，且有些疾病或并发症是不可根治的，需要您积极配合，医生已经尽力为您制定合理的在线诊疗方案，致力减少药物治疗不良反应的发生，但不可能完全避免，且不可预测，需要在您的配合下，且根据临床情况不断调整方案。如果您在在线诊疗中或在线诊疗后，发现自身的症状和体征发生改变或恶化，或有明显的身体不适，请您立即告知医生，并及时就近急诊就医，以免贻误病情。</p>
		
		<p>2.3 您确认为患者本人或监护人，虽然我们对患者的实名信息进行搜集和核验，但平台受限于线上问诊环境，不同于线下现场诊疗，无法实时核验患者的身份。平台及为您提供在线复诊服务的互联网医院将视同您为患者本人或作为患者的监护人。您在在线问诊过程中进行的任何操作行为，对患者均具有对应的法律效力。</p>
		
		<p>2.4 疾病的治愈需要您谨遵医嘱、健康管理方案，并积极配合。如果您未完全遵守和配合，则可能导致诊疗效果不理想，甚至出现病情反复、恶化等不良后果。</p>
		
		<p>2.5 如您正在用药物或手术等治疗其他疾病，也可能存在延时用药、联合用药等风险，此类情形请务必提前告知医生。</p>
		
		<p>2.6您自采药品的品牌、规格、性状、使用方法等可能影响本次诊疗方案的效果，同时还可能出现危害生命健康的风险。</p>
		
		<p>2.7 医生主要解决本专业领域的医疗问题，非本专业的疾病需要到其他专业科室进行诊治或接受远程医疗服务。</p>
		
		<p>本风险告知及知情同意书未能一一列出在线问诊场景下其他可能存在的风险，如果您有疑问请与医生进行沟通。</p>
		
		<p>3. 我们非常重视对您个人健康信息的保护，并遵循合法、正当、必要原则来收集您提交的各项个人健康信息，用于线上医生为您提供服务。</p>
		
		<p>您已充分知晓上述内容并作如下确认：</p>
		
		<p>由于医生仅通在线沟通收集病情资料，您确认如实、完整反馈个人情况（基本信息（真实的姓名、性别、年龄、身份证号）和病症信息（病情描述、过敏史、特殊体质备注等），并对提供信息的真实性准确性负责。</p>
		
		<p>您确认将严格按照医嘱用药，如遇到病情病情加重或其他严重不适症状应及时线下就医。</p>
		
		<p>在接受在线诊疗服务过程中，请您真实回答医生提出的问题，切勿故意隐瞒或虚报。由此造成的不良后果，由您本人负责。</p>
		
		<p>如您有药物过敏史，您须提前填写清楚，或告知医生或医生团队，同时用药过程中如有不适反应要主动、积极告知平台、医生或医生团队。</p>
		
		<p>您确认在互联网医院上问诊的疾病，已经在实体医疗机构明确诊断，您已经填写或上传相关的病历资料，愿意互联网诊疗。</p>
		
		<p>您确认既往发生过与本次发病类似的常见病、慢性病病症，并曾经在实体医院诊疗。</p>
		
		<p>您确认愿意接受医生根据诊疗经验为您提供的在线医疗服务。</p>
		
		<p>您确认已经知晓并同意以上内容，理解相关的风险，愿意接受互联网医院的服务以及接受疾病诊疗服务，并签署知情同意书。</p>
		
		<p>您确认未得到服务结果会百分之百成功的许诺。</p>
	</div>
</template>
<style>
	.title{
		font-size: 0.3rem;
		font-weight: bold;
		margin-top: 10px;
		margin-bottom: 10px;
	}
	p{
		text-indent:2em;
	}
</style>
<script>
	export default {
		name: "GoodsZdbook",
		components: {},
		data: function() {
			return {};
		},
		mounted: function() {},
		methods: {}
	};
</script>
